import React, { useEffect, useState } from 'react'
import styles from './Header.module.scss'
import { ReactComponent as DCLogo } from '../../assets/images/DC_logo_white.svg'
import { IncontextBanner } from '@digicert/dcone-common-ui'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { getValueFromState, isOauthFlow } from 'pages/login/Login.actions'
import cn from 'classnames'
import { HeaderProps } from './Header.types'

const Header = (
  {
    logoDataUri
  }: HeaderProps) => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search.includes('+') ? search.replace('+', encodeURIComponent('+')) : search)
  const [state] = useState(searchParams.get('state'))
  const [friendlyName, setFriendlyName] = useState('')
  const [isDtaOauthRequest, setIsDtaOauthRequest] = useState(false)

  useEffect(() => {
    if (state != null) {
      const isOauthTrue = isOauthFlow(state)
      const stateDecoded = atob(state)
      setIsDtaOauthRequest(getValueFromState("isDtaOauthRequest=", stateDecoded))
      if (isOauthTrue) {
        const fn = getValueFromState("friendly_name=", stateDecoded)
        if(fn !== "" ) {
          setFriendlyName(fn)
        }
      }
    }
  }, [])

  return (
    <div className={styles.header}>
      {logoDataUri
        ? (<img alt='' className={styles.dcOneLogo} src={logoDataUri}/>)
        : (<DCLogo className={styles.dcLogo} />)
      }
      <div className={cn(styles.bannerContainer, friendlyName !== '' && styles.show)}>
        {friendlyName !== '' && !isDtaOauthRequest &&
          <IncontextBanner
            bannerType="note"
            description={t('login.info', {name: friendlyName})}
          />
        }
      </div>
    </div>
  )
}

export default Header